(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("seqviz-dlw", [], factory);
	else if(typeof exports === 'object')
		exports["seqviz-dlw"] = factory();
	else
		root["seqviz-dlw"] = factory();
})(this, () => {
return 